import { EVENT_KEY, TRACKING_ACTION, TRACKING_INTERACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const classbookTracking = {
  trackClassbook (entity = 'classbook', result = 'SUCCESS', failedReason = null) {
    const action = {
      confirmAbsences: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.ACTION, { action: TRACKING_ACTION.CONFIRM_ALL }),
      toggleAbsence: ({ checked }) => trackingUtils.track(EVENT_KEY.CLASSBOOK.ACTION, { action: checked ? TRACKING_ACTION.MARK_ABSENT : TRACKING_ACTION.MARK_PRESENT })
    }

    const interaction = {
      lessonInfo: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_LESSON_INFO }),
      changeHistory: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_CHANGE_HISTORY }),
      clickEntity: ({ selectedEntity }) => trackingUtils.track(EVENT_KEY.CLASSBOOK.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_ENTITY, entity: selectedEntity })
    }

    const start = {
      create: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.CREATE, entity }),
      editAbsence: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.EDIT, entity }),
      usersAddToCourse: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.ADD, entity }),
      isConfirmLosingChangesModalDisplayed: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.REMOVE, entity }),
      editCourseEnrollmentModal: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.EDIT, entity }),
      export: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.EXPORT, entity }),
      edit: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.EDIT, entity }),
      delete: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.DELETE, entity }),
      history: () => trackingUtils.track(EVENT_KEY.CLASSBOOK.START, { action: TRACKING_ACTION.HISTORY, entity })
    }

    const end = {
      toggle: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.TOGGLE, entity, result, failedReason }),
      create: ({ trackGlobal = null }) => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.CREATE, trackGlobal, entity, result, failedReason }),
      absence: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.TOGGLE, entity, result, failedReason }),
      add: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.ADD, entity, result, failedReason }),
      save: ({ isEditMode = false, trackGlobal }) => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: isEditMode ? TRACKING_ACTION.EDIT : TRACKING_ACTION.CREATE, trackGlobal, entity, result, failedReason }),
      delete: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.DELETE, entity, result, failedReason }),
      edit: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.EDIT, entity, result, failedReason }),
      export: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.EXPORT, entity, result, failedReason }),
      remove: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.REMOVE, entity, result, failedReason }),
      confirmAbsences: () => trackingUtils.trackWithResult(EVENT_KEY.CLASSBOOK.END, { action: TRACKING_ACTION.CONFIRM_ALL, entity, result, failedReason })
    }

    return {
      action,
      interaction,
      end,
      start
    }
  }
}

export default classbookTracking
